import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmarkPlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bookmark-plus, banner, flag, tag"} maskId="square-filled-radius-0-stroke-1-IconBookmarkPlus"><path fillRule="evenodd" clipRule="evenodd" d="M4 2V21.8333L12 17.5667L20 21.8333V2H4ZM12.5 6V9.5H16V10.5H12.5V14H11.5V10.5H8V9.5H11.5V6H12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBookmarkPlus;
